import React, { Component } from 'react';
import { setActiveFeaturedSelection } from '../modules/active_featured_selection';
import { connect } from 'react-redux';
import { navigate } from '../modules/high_level_actions';
import { removeEnrollItem, removeCartProduct, updateProductCart } from '../modules/cart_actions';
import { openFeaturedSelectionsModal } from '../modules/active_modal';

class CommerceBarItem extends Component {

  constructor(props) {
    super(props);
    this.onCoverClick = this.onCoverClick.bind(this);
    this.loggedInSpecialRemoveProduct = this.loggedInSpecialRemoveProduct.bind(this);
  }

  loggedInSpecialRemoveProduct(product){
    if(product && product.quantity && product.quantity > 1 )
      this.props.dispatch( updateProductCart( product, product.quantity -1 ) );
    else
      this.props.dispatch( removeCartProduct(product) );
  }

  onCoverClick(evt) {
    if (this.props.i === 0 && this.props.isLoggedIn && this.props.status === 'Active' && !this.props.upgradeStatus) {
     this.props.dispatch( [setActiveFeaturedSelection( this.props.product ), openFeaturedSelectionsModal()]);
    }
    this.props.dispatch(navigate(evt));
  }
  render() {
    // set defaults for empty/undefined product
    let sImageSrc         = '';
    let productContents   = <div className="item-holder" />;
    let removeEl          = '';
    let sMemberCartPrice  = '';
    let sFSNoCredit       = '';
    let tempPrice         = this.props.tempPrice || "";
    //Show bundle pricing if a FS is choosen or cart is completely empty
    let sItemState = (this.props.computedCart.items[0] || this.props.computedCart.items.length === 0 ) ? ' bundle-pricing' : '' ;
    if (!this.props.isLoggedIn) sItemState = ' bundle-pricing';
    if (this.props.product) {
      let oProduct = this.props.product;
      if(!this.props.store_bundle_pricing && this.props.isLoggedIn && this.props.status === 'Active'  && !this.props.upgradeStatus ) tempPrice = '$' + oProduct.sale_price;
      let sPath = (this.props.i === 0 && this.props.isLoggedIn && this.props.status === 'Active' && !this.props.upgradeStatus ) ? "#" : "/catalog/product/" + oProduct.id + '-' + oProduct.url;
      let sMMID = (this.props.product.format !== 'regular' && this.props.product[this.props.product.format] ? this.props.product[this.props.product.format].mmid : this.props.product.mmid );
      sImageSrc       = '//s3.amazonaws.com/bookspan-media/covers/full/' + sMMID + '.jpg';
      productContents = <a href={sPath} onClick={this.onCoverClick}><div className="product-scaled-wrapper"><img className="product-scaled" src={sImageSrc} /></div></a>;
      removeEl        = (<div
        className="remove inline"
        onClick={() => (this.props.isLoggedIn && this.props.status === 'Active' && !this.props.upgradeStatus ) ?
          this.loggedInSpecialRemoveProduct(this.props.product)
          : this.props.dispatch(removeEnrollItem(this.props.i)) }>
          <svg version="1.1" x="0px" y="0px" width="22.666px" height="22.667px" viewBox="0 0 22.666 22.667" enable-background="new 0 0 22.666 22.667">
            <path id="bgFill" fill="#FFFFFF" d="M20.332,11.128c0,11.907-18.418,11.907-18.418,0C1.914-0.778,20.332-0.779,20.332,11.128
              C20.332,16.214,20.332,6.042,20.332,11.128z"/>
            <path fill="#231F20" d="M11.379,22.325c-6.108,0-11.078-4.969-11.078-11.077S5.271,0.169,11.379,0.169s11.077,4.97,11.077,11.078
              S17.487,22.325,11.379,22.325z M11.379,2.669c-4.73,0-8.578,3.848-8.578,8.578c0,4.729,3.848,8.577,8.578,8.577
              c4.729,0,8.577-3.848,8.577-8.577C19.956,6.518,16.108,2.669,11.379,2.669z"/>
            <polygon fill="#231F20" points="17.759,6.675 15.991,4.907 11.587,9.313 7.182,4.907 5.415,6.675 9.819,11.081 5.415,15.487
              7.182,17.254 11.587,12.848 15.991,17.254 17.759,15.487 13.354,11.081 "/>
          </svg>
        </div>);
    } else  tempPrice = '';

    // Set FS pricing indicator to always be full price it credits are not available
    sFSNoCredit = (this.props.tempPrice === '' && this.props.i === 0 && this.props.store_bundle_pricing ) ? ' no-credit' : ' use-credit' ;

    return (
      <div className="item-wrapper">
        <div className={ "price-flag" + sItemState + sFSNoCredit }>{tempPrice}</div>
        {productContents}
        {removeEl}
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'preorder_price': state.store.preorder_price,
      'isLoggedIn': state.isLoggedIn,
      'computedCart': state.computedCart,
      'upgradeStatus': state.upgradeStatus,
      'store_bundle_pricing': state.store.bundle_pricing
    };
}

export default connect(mapStateToProps)(CommerceBarItem);



// WEBPACK FOOTER //
// ./src/components/CommerceBarItem.jsx